// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-50cc2552] .p-dialog-header{font-weight:600}[data-v-50cc2552] .p-tabview-nav{flex-wrap:wrap}", ""]);
// Exports
module.exports = exports;
